<template>
        <b-col class="my-4" :cols="quizAnswersColumnsAnchor ? 6 : 12" :lg="quizAnswersColumnsAnchor ? quizAnswersColumnsAnchor : 12">
            <span @click="!readOnly ? $emit('elementSelected') : null" :class="{'answer-box': true, 'quiz-answer-selected': itemSelected}" white>{{answer}}</span>
        </b-col>
</template>

<script>
import BaseInput from '@/components/base/forms/BaseInput'

export default {
    components: {
        BaseInput
    },
    props: {
        id: {
            type: String,
            required: true
        },
        answer: {
            type: String,
            required: true
        },
        answersSelected: Array,
        quizAnswersColumnsAnchor: Number,
        readOnly: Boolean
    },
    data () {
        return {
        }
    },
    created () {
    },
    methods: {
    },
    computed: {
        itemSelected () {
            return this.answersSelected.some(item => item.answerId === this.id)
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-answer-selected{
    background-color: $green !important;
    color: white;
}
.answer-box{
  border-radius: 23px;
  background-color: white;
  padding: 15px;
  cursor: pointer;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/quiz/ClinicHistoryQuizAnswer.vue